import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { commercialEmail, mailtoUrl, supportEmail } from '@/configs';
import PhoneQuotaReachedNotice from './PhoneQuotaReachedNotice.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyPhoneQuotaSummary',
  props: {
    used: { type: Number, required: true },
    limit: { type: [Number, null], required: true },
    full: { type: Boolean, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;
const { t } = useI18n();

const label = computed(() =>
    props.limit === null
        ? t('whatsappMeta.quota.unlimited', { used: props.used })
        : t('whatsappMeta.quota.limited', { used: props.used, limit: props.limit }),
);
const requestIncreaseUrl = computed(() =>
    mailtoUrl(
        commercialEmail,
        supportEmail,
        t('whatsappMeta.quota.requestSubject'),
        t('whatsappMeta.quota.requestBody', { used: props.used, limit: props.limit ?? '-' }),
    ),
);

const __returned__ = { props, t, label, requestIncreaseUrl, PhoneQuotaReachedNotice }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})